import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HeaderMessageStateService {
  private _customTenantMessageVisibilitySource = new BehaviorSubject<boolean>(
    false
  );
  customTenantMessageVisibility$ =
    this._customTenantMessageVisibilitySource.asObservable();

  constructor() {}

  setCustomTenantMessageVisibility(visibility: boolean): void {
    this._customTenantMessageVisibilitySource.next(visibility);
  }

  getCustomTenantMessageVisibilityValue(): boolean {
    return this._customTenantMessageVisibilitySource.getValue();
  }

  getCustomTenantMessageVisibility(): Observable<boolean> {
    return this.customTenantMessageVisibility$;
  }
}
